import * as Sentry from '@sentry/vue';

/**
 * Initialize the Sentry browser SDK.
 *
 * Reads its config from `window.config.sentry`, which the backend only injects
 * when a DSN is configured. When absent, this is a no-op so dev/local builds
 * stay completely silent.
 *
 * @param {import('vue').App} app   The Vue application instance
 * @param {import('vue-router').Router} router  Router for navigation tracing
 */
export function initSentry(app, router) {
    const config = window.config?.sentry;
    if (!config?.dsn) {
        return;
    }

    Sentry.init({
        app,
        dsn: config.dsn,
        environment: config.environment,
        release: config.release,
        integrations: [Sentry.browserTracingIntegration({ router })],
        tracesSampleRate: config.tracesSampleRate ?? 0
    });
}

/**
 * Tag the current Sentry scope with the active organization so events can be
 * filtered per tenant. Safe to call even when Sentry was not initialized.
 */
export function setSentryOrg({ id, slug }) {
    if (!slug) {
        return;
    }
    Sentry.setTag('org', slug);
    Sentry.setTag('org_id', String(id ?? ''));
}

/**
 * Report an exception to Sentry. No-op when Sentry was not initialized.
 */
export function captureSentryException(error) {
    Sentry.captureException(error);
}
